import { Card, CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";

import MDBox from "@/components/atoms/MDBox";
import Suspense from "@/components/molecules/Suspense";
import ChatHistory from "@/components/screens/Chat/components/CurrentChat/ChatHistory";
import useContactData from "@/hooks/data/use-contact-data";
import useGetConversationMessages from "@/hooks/requests/conversations/uset-get-conversation-messages";
import { CHAT_MESSAGES } from "@/messages/chat/chat.messages";

type Props = {
  conversationId: number;
};

export default function ChatTab({ conversationId = 0 }: Props) {
  const messages = CHAT_MESSAGES;
  const { conversationMessages, contact, isLoading } = useGetConversationMessages(conversationId);
  const { fullName } = useContactData({ messages, contact });

  return (
    <MDBox my={2}>
      <Grid container spacing={3} justifyContent="center">
        <Grid size={{ xs: 12, lg: 12 }}>
          <Card>
            <MDBox pt={2} px={2}>
              <Suspense isSuspended={isLoading} fallback={<CircularProgress size={50} />}>
                {contact && (
                  <ChatHistory
                    contactId={contact.id}
                    contactName={fullName!}
                    messages={messages}
                    conversationMessages={conversationMessages?.messages}
                  />
                )}
              </Suspense>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}
